import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  h1: () => i18n.t(i18nKeys.profileSetup__h1),
  instructions: () => i18n.t(i18nKeys.profileSetup__instructions),
  required: () => i18n.t(i18nKeys.common__required),
  firstName: () => i18n.t(i18nKeys.common__firstName),
  middleName: () => i18n.t(i18nKeys.common__middleName),
  noMiddleNameLabel: () => i18n.t(i18nKeys.profileSetup__noMiddleNameLabel),
  lastName: () => i18n.t(i18nKeys.common__lastName),
  referralToggle: () => i18n.t(i18nKeys.profileSetup__referralToggle),
  referrerPhoneLabel: () => i18n.t(i18nKeys.profileSetup__referrerPhoneLabel),
  optional: () => i18n.t(i18nKeys.common__optional),
  h2: () => i18n.t(i18nKeys.profileSetup__h2),
  password: () => i18n.t(i18nKeys.common__password),
  passwordDescription: () => i18n.t(i18nKeys.profileSetup__passwordDescription),
  passwordPlaceholder: () => i18n.t(i18nKeys.profileSetup__passwordPlaceholder),
  passwordShow: () => i18n.t(i18nKeys.profileSetup__passwordShow),
  passwordHide: () => i18n.t(i18nKeys.profileSetup__passwordHide),
  continue: () => i18n.t(i18nKeys.common__continue),
  CAofferTitle: () => i18n.t(i18nKeys.profileSetup__CAOfferTitle),
  CAofferLink: () => i18n.t(i18nKeys.profileSetup__CAOfferLink),
  CAofferLegal: () => i18n.t(i18nKeys.profileSetup__CAOfferLegal),
}
